module.exports = __webpack_public_path__ + "img/visa-debito-premium-world.935567f5.png";